var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKik({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 14.25C16.25 14.9793 16.5397 15.6788 17.0555 16.1945C17.5712 16.7103 18.2707 17 19 17C19.7293 17 20.4288 16.7103 20.9445 16.1945C21.4603 15.6788 21.75 14.9793 21.75 14.25C21.75 13.5207 21.4603 12.8212 20.9445 12.3055C20.4288 11.7897 19.7293 11.5 19 11.5C18.2707 11.5 17.5712 11.7897 17.0555 12.3055C16.5397 12.8212 16.25 13.5207 16.25 14.25Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 1.5C4.14782 1.5 4.52936 1.65804 4.81066 1.93934C5.09196 2.22064 5.25 2.60218 5.25 3V13.879L11.69 7.439C11.973 7.16589 12.352 7.01488 12.7453 7.01848C13.1386 7.02208 13.5147 7.18001 13.7927 7.45826C14.0707 7.7365 14.2283 8.1128 14.2315 8.50609C14.2347 8.89939 14.0834 9.27823 13.81 9.561L9.68 13.691L13.998 20.168C14.2135 20.499 14.2897 20.9017 14.2101 21.2885C14.1305 21.6754 13.9015 22.0153 13.5729 22.2344C13.2443 22.4534 12.8425 22.5341 12.4548 22.4587C12.0671 22.3834 11.7247 22.1582 11.502 21.832L7.517 15.854L5.25 18.122V21C5.25 21.3978 5.09196 21.7794 4.81066 22.0607C4.52936 22.342 4.14782 22.5 3.75 22.5C3.35218 22.5 2.97064 22.342 2.68934 22.0607C2.40804 21.7794 2.25 21.3978 2.25 21V3C2.25 2.60218 2.40804 2.22064 2.68934 1.93934C2.97064 1.65804 3.35218 1.5 3.75 1.5Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKik);
export default __webpack_public_path__ + "static/media/kik.8eac0381772f145c47a12e3f41115ee8.svg";
export { ForwardRef as ReactComponent };